import type { ChecklistItem, Options, StateType, TempStateType, Theme } from "./types";
import defaultChecklistItemsJSON from "./Checklist/checklistItems.json";

export const allThemes: Theme[] = ["black", "light", "frappe"];

export const developmentVersion: "development" = "development";

export const defaultOptions: Options = {
    theme: "black",
    darNotifications: true,
    notificationPermission: false,
    keyboardShortcuts: false,
};

export const defaultChecklistItems = defaultChecklistItemsJSON as ChecklistItem[];

const defaultState: StateType = {
    count: 0,
    lastUpdated: "",
    lastUpdatedString: "Never",
    checklistItems: defaultChecklistItems,
    percentChecklistItemsComplete: 0,
    version: {
        version: "",
        timestamp: "",
    },
    options: defaultOptions,
    noSleepIsEnabled: false,
};

const defaultTempState: TempStateType = {
    theme: defaultOptions.theme,
    upsideDown: false,
    sideBarHidden: true,
};

export const State: StateType = $state(defaultState);

export const TempState: TempStateType = $state(defaultTempState);